import Colors from "../../../../theme/colors";

const styles = {
  dropdown: {
    minWidth: "200px",
  },

  disabled: {
    opacity: 0.5,
    pointerEvents: "none",
  },

  dropdownBtn: {
    display: "flex",
    justifyContent: "space-between",
  },

  leftSideBtn: {
    display: "flex",
    alignItems: "center",
    width: "100%",
    // cursor: "pointer",
    justifyContent: "center",
    gap: "8px",
    borderRadius: "8px 0px 0px 8px",
    fontWeight: "600",
    height: "38px",
    fontSize: "12px",
    lineHeight: "24px",
    // background: "#CECECE",
    // color: "#000000",
    // border: "1px solid #000000",
    padding: "6px 8px",
  },

  dropdownContent: {
    background: "#FFFFFF",
    border: "1px solid rgba(97, 97, 97, 0.5)",
    borderRadius: "8px",
    marginTop: "4px",
  },

  dropdownItems: {
    margin: "6px 8px",
    padding: "6px 8px",
    cursor: "pointer",
    borderBottom: ".5px solid rgba(97, 97, 97, 0.5)",
  },

  arrowIcon: {
    background: Colors.white,
    color: Colors.midnightBlue,
    border: ` 1px solid ${Colors.midnightBlue} `,
    borderRadius: "0px 8px 8px 0px",
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
    "&:hover": {
      backgroundColor: Colors.white,
      color: Colors.hoverBlue,
      border: `1px solid ${Colors.hoverBlue}`,
    },
    // padding: "6px 8px",
    ml: "2px",
  },
};

export default styles;
